import script from "./LandingPageWorkLocationMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageWorkLocationMobile.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageWorkLocationMobile.vue?vue&type=style&index=0&id=5a1b48ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1b48ed"]])

export default __exports__